<template>

	<div v-show="!pager.errorMessage">
		<div class="text-right mb10">
			<button class="btn btn-sm btn-info" @click="show=!show">
				<i class="fa fa-filter"></i>
				<span v-if="show">
            收起筛选
          </span>
				<span v-else>
            打开筛选
        </span>
			</button>
		</div>
		<NbExpanding>
			<div v-show="show" class="col-xs-12 bg-aliceblue border-dash mb10">

				<div class="form-horizontal pt10 pb10">

					<div class="form-group" v-for="filter in filters" v-if="filter.type === 'INPUT'">
						<label class="col-xs-2 control-label pt7">{{filter.name}}</label>
						<div class="col-xs-10">
							<div class="row">
								<div class="col-md-4">
									<input type="text" :placeholder="filter.name" v-model="filter.value" class="form-control"
									       @keyup.enter="search">
								</div>
							</div>
						</div>
					</div>

					<div class="form-group" v-if="hasSortType">
						<label class="col-xs-2 control-label pt7">排序</label>
						<div class="col-xs-10">

							<span v-for="filter in filters" v-if="filter.type === 'SORT'">
								<NbFilterSort :filter="filter" :callback="search"/>
							</span>

						</div>
					</div>

					<div class="form-group" v-if="hasCheckType">
						<label class="col-xs-2 control-label pt7">勾选</label>
						<div class="col-xs-10">

							<span v-for="filter in filters" v-if="filter.type === 'CHECK'">
								<NbFilterCheck :filter="filter" :callback="search"/>
							</span>

						</div>
					</div>

					<div class="form-group" v-for="filter in filters" v-if="filter.type === 'SELECTION'">
						<label class="col-xs-2 control-label pt7">{{filter.name}}</label>
						<div class="col-xs-10">
							<NbFilterSelection :filter="filter" :callback="search"/>
						</div>
					</div>

					<div class="form-group" v-for="filter in filters" v-if="filter.type === 'MULTI_SELECTION'">
						<label class="col-xs-2 control-label pt7">{{filter.name}}</label>
						<div class="col-xs-10">
							<NbFilterMultiSelection :filter="filter" :callback="search"/>
						</div>
					</div>



					<div class="form-group" v-for="filter in filters" v-if="filter.type === 'HTTP_SELECTION'">
						<label class="col-xs-2 control-label pt7">{{filter.name}}</label>
						<div class="col-xs-10">
							<NbFilterHttpSelection :filter="filter" :callback="search"/>
						</div>
					</div>

					<div class="text-right">
						<button class="btn btn-sm btn-primary" @click="search">
							<i class="fa fa-search"></i>
							搜索
						</button>
					</div>

				</div>
			</div>
		</NbExpanding>
	</div>

</template>

<script>

	import NbExpanding from '../NbExpanding'
	import Pager from "../../model/base/Pager";
	import Filter from "../../model/base/Filter";
	import NbFilterSort from "./NbFilterSort";
	import NbFilterCheck from "./NbFilterCheck";
	import NbFilterSelection from "./NbFilterSelection";
	import NbFilterMultiSelection from "./NbFilterMultiSelection";
	import NbFilterHttpSelection from "./NbFilterHttpSelection";
	export default {
		data () {
			return {
				show: false
			}
		},
		components: {
			NbExpanding,
			NbFilterSort,
			NbFilterCheck,
			NbFilterSelection,
			NbFilterMultiSelection,
			NbFilterHttpSelection
		},
		props: {
			pager: {
				type: Pager,
				required: true,
				validator: function (value) {
					return true;
				}
			},
			callback: {
				type: Function,
				required: false
			}
		},
		computed: {
			filters(){
				return this.pager.FILTERS;
			},
			hasSortType(){
				for (let i = 0; i < this.filters.length; i++) {
					let filter = this.filters[i];
					if (filter.type === Filter.prototype.Type.SORT) {
						return true;
					}
				}
				return false;
			},
			hasCheckType(){
				for (let i = 0; i < this.filters.length; i++) {
					let filter = this.filters[i];
					if (filter.type === Filter.prototype.Type.CHECK) {
						return true;
					}
				}
				return false;
			}

		},
		watch: {},
		methods: {
			search(){
				this.callback && this.callback();
			}
		},
		mounted(){

		}
	}
</script>



// WEBPACK FOOTER //
// NbFilter.vue?341408ea